import { HeaderBagRepositoryInterface } from '../../../data/repositories/ptz-header-bag/ptz-header-bag.repository';
import { PTZHeaderTypes } from '../../../types/ptz-header.types';

class DeleteHeaderBagUseCase {
  constructor(
    private readonly baseUrl: string,
    private readonly bagId: string,
    private readonly token: string,
    private readonly repository: HeaderBagRepositoryInterface,
    private readonly tokenAuthErrorHandler: () => void,
  ) {}

  async deleteBagProduct(sku: string, quantity: number): Promise<PTZHeaderTypes.BagProductAPIResponse> {
    return await this.repository.deleteBagProduct({
      baseUrl: this.baseUrl,
      token: this.token,
      bagId: this.bagId,
      sku,
      quantity,
      tokenAuthErrorHandler: this.tokenAuthErrorHandler,
    });
  }
}

export default DeleteHeaderBagUseCase;
